import React, { createContext } from "react";

const authContextData = {
    user: {
        permissions: {},
        role: "",
        isVisaoTok: false,
    },
};

export const AuthContext = createContext(authContextData);

export const AuthProvider = ({ children, permissions = {}, role = "" }) => {
    return (
        <AuthContext.Provider
            value={{
                user: {
                    permissions,
                    role,
                    isVisaoTok: !!permissions["filtro-fornecedor"],
                },
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
